function getUserAgent(): string {
  return navigator.userAgent;
}

export default {
  getUserAgent,
};
